import { useCompanyQuery } from '../graphql/query/company.query'
import { useAppSelector } from '../store'
import { ID } from '../utils/id'
import { useProfile } from './use.profile'

interface Permissions {
  isAdmin: boolean
  isMember: boolean
  isWorker: boolean
  isStaff: boolean
  loading: boolean
}

interface Options {
  company?: ID
}

export const usePermission = (options: Options = {}): Permissions => {
  const storedCompanyId = useAppSelector((state) => state.company.id)

  const companyId = options.company ?? storedCompanyId

  const company = useCompanyQuery({
    skip: !companyId,
    variables: {
      id: companyId,
    },
  })

  const profile = useProfile()

  return {
    isAdmin: company.data?.company.isAdmin,
    isMember: company.data?.company.isMember,
    isStaff: profile.profile?.isStaff,
    isWorker: company.data?.company.isWorker,
    loading: company.loading || profile.loading,
  }
}
